import React from "react";
import { Routes, Route, NavLink } from "react-router-dom";
import Layout from "../common/Layout";
import UserManagement from "./UserManagement";
import DmsManagement from "./DmsManagement";
import ProductManagement from "./ProductManagement";
import MasterDataManagement from "./MasterDataManagement";
import BookingAppManagement from "./BookingAppManagement";
import AdminNotifications from "./AdminNotifications";
import IntegrationsPage from "./integrations/IntegrationsPage";
import PendingUsers from "./PendingUsers";
import SystemHealth from "./SystemHealth";

function AdminDashboard() {
  return (
    <Layout title="Admin Dashboard" subtitle="Manage system configuration">
      <div className="admin-tabs">
        <NavLink to="/admin/users" className="admin-tab">
          <i className="fas fa-users"></i> Users
        </NavLink>
        <NavLink to="/admin/dms" className="admin-tab">
          <i className="fas fa-server"></i> DMS Providers
        </NavLink>
        <NavLink to="/admin/products" className="admin-tab">
          <i className="fas fa-boxes"></i> Products
        </NavLink>
        <NavLink to="/admin/master" className="admin-tab">
          <i className="fas fa-database"></i> Master Data
        </NavLink>
        <NavLink to="/admin/booking-apps" className="admin-tab">
          <i className="fas fa-calendar-check"></i> Booking Apps
        </NavLink>
        <NavLink to="/admin/notifications" className="admin-tab">
          <i className="fas fa-bell"></i> Notifications
        </NavLink>
        <NavLink to="/admin/pending-users" className="admin-tab">
          <i className="fas fa-user-clock"></i> Pending Users
        </NavLink>
        <NavLink to="/admin/system" className="admin-tab">
          <i className="fas fa-heartbeat"></i> System
        </NavLink>
        <NavLink to="/admin/integrations" className="admin-tab">
          <i className="fas fa-plug"></i> Integrations
        </NavLink>
      </div>

      <div className="admin-content">
        <Routes>
          <Route index element={<UserManagement />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="dms" element={<DmsManagement />} />
          <Route path="products" element={<ProductManagement />} />
          <Route path="master" element={<MasterDataManagement />} />
          <Route path="booking-apps" element={<BookingAppManagement />} />
          <Route path="notifications" element={<AdminNotifications />} />
          <Route path="pending-users" element={<PendingUsers />} />
          <Route path="system" element={<SystemHealth />} />
          <Route path="integrations/*" element={<IntegrationsPage />} />
        </Routes>
      </div>
    </Layout>
  );
}

export default AdminDashboard;
